import axios from 'axios'
// import { Toast } from 'vant';
// import {setUserInfo,getUserInfo} from "@/utils/Auth";
import router from '@/router'
import Vue from 'vue';
import {Notification} from 'element-ui'
import {getToken} from './auth';
import { Loading } from 'element-ui';

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。请打开网络',
};

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 5000 * 200, //1m request timeout
  method: 'post',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',

  },
  crossDomain: true
});

service.interceptors.request.use(config => {
    // Authorization:'Bearer token '+timestamp:MD5(token + timestamp + url)
  // if (localStorage.getItem("token")) {
    var time = Date.now();
    // console.log("config.url",config.url,config);
    config.headers['token'] = getToken();
    // console.log("d",config);
  // }else{
  //   message.info('请先登录');
  //   window.location.href="http://localhost:3000/#/login";
  // }
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(
  response => {
    // console.log('res',response);
    if(response.data && response.data.status=="OVERTIME_LOGIN"){
      //跳转登录页面；
      router.replace({path:"/login"});
    }
    return Promise.resolve(response.data) //使用Promise.resolve 正常响应
    // if (response.data.code === 0) {   //服务端定义的响应code码为0时请求成功
    // }else {
    //   return Promise.reject(response.data)
    // }
  },
  error => {
    // if (error && error.response) {
    //   let res = {}
    //   res.code = error.response.status
    //   res.msg = throwErr(error.response.status, error.response) //throwErr 捕捉服务端的http状态码 定义在utils工具类的方法
    //   return Promise.reject(res)
    // }
    // console.log('reserr',error);
    return Promise.reject(error)
  }
)
const errorHandler = error => {
  const { response = {} } = error;
  // console.log('errorresponse',error);
  const errortext = codeMessage[response.status] || response.statusText;
  const { status, url } = response;
  // alert(errortext);

    Notification({
      title: '错误',
      message: errortext,
      type: 'error'
    })

  // if (!status) {
  //   return;
  // }
}
export   function parseUrl(url) {
    if(url.indexOf("http")==-1){
      url='http://test.com'+url;
    }
    let urlObj = {
        protocol: /^(.+)\:\/\//,
        host: /\:\/\/(.+?)[\?\#\s\/]/,
        path: /\w(\/.*?)[\?\#\s]/,
        query: /\?(.+?)[\#\/\s]/,
        hash: /\#(\w+)\s$/
    }
    url += ' '
    function formatQuery(str) {
        return str.split('&').reduce((a, b) => {
            let arr = b.split('=')
            a[arr[0]] = arr[1]
            return a
        }, {})
    }
    for(let key in urlObj) {
        let pattern = urlObj[key]
        urlObj[key] = key === 'query' ? (pattern.exec(url) && formatQuery(pattern.exec(url)[1])) : (pattern.exec(url) && pattern.exec(url)[1])
    }
    return urlObj
}
export function createFormdata(params) {
  const formData = new FormData();
  for (var key in params) {
    if(params[key] && params[key].push && params[key] instanceof Array){
      if(params[key].length){
        for(var i=0;i<params[key].length;i++){
          formData.append(key, params[key][i]);
        }
      }else{
        formData.append(key,null)
      }
    }else{
      formData.append(key,params[key])
    }
  }
  return formData;
}
var loading_instance=null;
function loadingHandler(text){
  if(text){
    if(loading_instance) closeRequestLoading();
    loading_instance=Loading.service({ fullscreen: true });

  //   loading_instance = Toast.loading({
  //   duration: 0, // 持续展示 toast
  //   forbidClick: true,
  //   message: text
  // });


  }
}
function closeRequestLoading(){
//  Toast.clear();
  if (loading_instance){
    loading_instance && loading_instance.close();
    loading_instance=null;
  }
}
export default {
  async post(url,data,loadingText="",headers={}){
    return new Promise((resolve,reject)=>{
      // if(headers)
      loadingHandler(loadingText);
      // setTimeout(()=>{
        service.post(url, data,{
           headers: headers
        }).then((res)=>{
          closeRequestLoading();
          if(res.error!==0){
            // alert(res.message);
             Notification({
                title: '错误',
                message: res.message,
                type: 'error'
              })
          }
          resolve(res);

        }).catch(err=>{
          reject(err);
          errorHandler(err);
          closeRequestLoading();
        })
      // },2000)
    })
  },
  async get(url,data={},loadingText="",headers={}){
    // alert(url+"`111")
    // console.warn("111",data);
    return new Promise((resolve,reject)=>{
      loadingHandler(loadingText);
      service.get(url,{params:data, headers: headers}).then((res)=>{
          resolve(res);
          closeRequestLoading();
      }).catch(err=>{
        reject(err);
        errorHandler(err);
        closeRequestLoading();
      })
    })
  },
  async delete(url,data={},loadingText="",headers={}){
    return new Promise((resolve,reject)=>{
      loadingHandler(loadingText);
      service.post(url, {params:data,headers: headers}).then((res)=>{
          resolve(res);
          closeRequestLoading();
      }).catch(err=>{
        reject(err);
        closeRequestLoading();
        errorHandler(err);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js